import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useLocation } from 'react-router-dom';
import * as S from './SiderMenu.styles';
import { sidebarNavigation, SidebarNavigationItem } from '../sidebarNavigation';
import { useAppSelector } from '@app/hooks/reduxHooks';
import { UserModel } from '@app/domain/UserModel';

interface SiderContentProps {
  setCollapsed: (isCollapsed: boolean) => void;
}

const sidebarNavFlat = sidebarNavigation.reduce(
  (result: SidebarNavigationItem[], current) =>
    result.concat(current.children && current.children.length > 0 ? current.children : current),
  [],
);

const getPermission = (section: string, user: UserModel | null): boolean => {
  if (!user) return false;

  switch (section) {
    case 'admins':
      return user.GOD;

    case 'team':
      return user.GOD;

    case 'users':
      return user.GOD || user.USER;

    case 'designers':
      return user.GOD || user.DESIGNER;

    case 'categories':
      return user.GOD || user.CATEGORY;

    case 'patterns':
      return user.GOD || user.PATTERN;

    case 'comments':
      return user.GOD || user.COMMENT;

    case 'comments':
      return user.GOD || user.COMMENT;

    case 'financial':
      return user.GOD || user.FINANCE;

    case 'messages':
      return user.GOD || user.PUBLIC;

    case 'orders':
      return user.GOD || user.ORDER;

    default:
      return false;
  }
};

const SiderMenu: React.FC<SiderContentProps> = ({ setCollapsed }) => {
  const user = useAppSelector((state) => state.user.user);
  const { t } = useTranslation();
  const location = useLocation();

  const currentMenuItem = sidebarNavFlat.find(({ url }) => url === location.pathname);
  const defaultSelectedKeys = currentMenuItem ? [currentMenuItem.key] : [];

  const openedSubmenu = sidebarNavigation.find(({ children }) =>
    children?.some(({ url }) => url === location.pathname),
  );
  const defaultOpenKeys = openedSubmenu ? [openedSubmenu.key] : [];

  return (
    <S.Menu
      mode="inline"
      defaultSelectedKeys={defaultSelectedKeys}
      defaultOpenKeys={defaultOpenKeys}
      onClick={() => setCollapsed(true)}
      items={sidebarNavigation.map((nav) => {
        const isSubMenu = nav.children?.length;
        const permission = getPermission(nav.key, user);

        return permission
          ? {
              key: nav.key,
              title: t(nav.title),
              label: isSubMenu ? t(nav.title) : <Link to={nav.url || ''}>{t(nav.title)}</Link>,
              icon: nav.icon,
              children:
                isSubMenu &&
                nav.children &&
                nav.children.map((childNav) => ({
                  key: childNav.key,
                  label: <Link to={childNav.url || ''}>{t(childNav.title)}</Link>,
                  title: t(childNav.title),
                })),
            }
          : null;
      })}
    />
  );
};

export default SiderMenu;
